import { gql } from '@apollo/client';

export const GET_LICENSE = gql`
  query license($args: LicenseInput!) {
    license(args: $args) {
      licenseName
      licenseUrl
      spdxId
      licenseType
      url
      additionalInfoUrlsList
      licenseNotes
    }
  }
`;
